import React from 'react';


class   InputTag extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      disabled: false,
      tags: []
    };

  }

  componentDidMount() {
    this.setState({ tags: this.props.synonyms, disabled: this.props.disabled })
  }

  removeTag = (i) => {
    if(this.props.disabled)
      return;
    const newTags = [...this.state.tags];
    newTags.splice(i, 1);
    this.setState({ tags: newTags });
    this.props.onArrayChange(newTags);
  }

  inputKeyDown = (e) => {
    var val = e.target.value;
    if (e.key === 'Enter' && val || e.key === 'Tab' && val) {
      if (this.state.tags.find(tag => tag.toLowerCase() === val.toLowerCase())) {
        if(e.key === 'Enter')
          e.preventDefault();
          return;
      }
      val = val.trim()
      this.setState({ tags: [...this.state.tags, val] });
      this.tagInput.value = null;
      this.props.onArrayChange([...this.state.tags, val]);
    } else if (e.key === 'Backspace' && !val) {
      this.removeTag(this.state.tags.length - 1);
    }
    
    if(e.key === 'Enter')
      e.preventDefault();
  }

  render() {
    const { tags } = this.state;

    return (
      <div className="input-tag">
        <ul className="input-tag__tags">
          {tags.map((tag, i) => (
            <li key={tag}>
              {tag}
              <button className="" type="button" onClick={() => { this.removeTag(i); }}>+</button>
            </li>
          ))}
          <li className="input-tag__tags__input"><input type="text" id={this.props.id} disabled={this.props.disabled} onKeyDown={this.inputKeyDown} ref={c => { this.tagInput = c; }} /></li>
        </ul>
      </div>
    );
  }
}


export default InputTag;